import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {ErrorCode} from "../enums/error-codes";
import {User} from "../entities/user/user";
import {UserService} from "../users/user.service";
import {Pagination} from "../entities/pagination";
import {Sorting} from "../entities/sorting";
import {ActivatedRoute} from "@angular/router";
import {Subscription, Subject} from "rxjs";
import {GroupType} from "../enums/group-type.enum";
import {ModalComponent} from "ng2-bs3-modal/components/modal";
import {FormGroup, FormBuilder} from "@angular/forms";
import {BusinessType} from "../enums/business-type";
import {CountryService} from "../country.service";
import {HttpClient} from "../http.client";
declare var $: any;

export class Size {
  minimum: number = -1;
  maximum: number = -1;
  range1: boolean = false;
  range2: boolean = false;
  range3: boolean = false;
  range4: boolean = false;
  range5: boolean = false;
  range6: boolean = false;
  range7: boolean = false;
  range8: boolean = false;
  range9: boolean = false;
  range10: boolean = false;
}
export class Fancy {
  straight_color:boolean = false;
  intensity: string[] = [];
}
export class White {
  cut: string[] = [];
}

export class Collection {
    id: number;
    name: string;
    description: string;
    shape: string[] = [];
    size: Size = new Size();
    price: {
      minimum: number;
      maximum: number;
    };
    clarity: string[] = [];
    color: string[] = [];
    polish: string[] = [];
    symmetry: string[] = [];
    fluorescence: string[] = [];
    lab: string[] = [];
    find_pair: boolean = false;
    mounted: boolean = false;
    location: string[] = [];
    lot_id: string[] = [];
    search_type: number = 1;
    fancy: Fancy = new Fancy();
    white: White = new White();
    display_order: number;
    image: string;
}


@Component({
  selector: 'collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.css']
})

export class CollectionComponent implements OnInit {

    lotIds: any[] = [];
    @ViewChild('lotIdsSelect') lotIdsSelect;

    locations: any[] = [];

    public shape:Array<string> =
    ['BR', 'RA', 'CU', 'EM',
    'SQEM', 'CARRE','PR', 'PS', 'OV',
    'HS', 'MQ', 'other'];

    public clarity:Array<string> =
    ['FL', 'IF', 'VVS1', 'VVS2',
    'VS1', 'VS2','SI1', 'SI2-'];

    public color:Array<string> =
    ['D', 'E', 'F', 'G',
    'H', 'I','J', 'K', 'L-O'];

    public fcolor:Array<string> =
    ['Yellow', 'Orange', 'Pink', 'Purple',
    'Blue', 'Green', 'Red', 'Brown'];

    public polish:Array<string> =
    ['EX', 'VG', 'G', 'G-'];

    public symmetry:Array<string> =
    ['EX', 'VG', 'G', 'G-'];

    public fluorescence:Array<string> =
    ['NON', 'FNT', 'MED', 'STRONG'];

    public lab:Array<string> =
    ['GIA', 'HRD', 'OTHER'];

    public intensity:Array<string> =
    ['Light', 'Fancy Light', 'Fancy', 'Intense',
    'Deep', 'Vivid'];

    public cut:Array<string> =
    ['EX', 'VG', 'G', 'G-'];


    @ViewChild('image') el:ElementRef;
    @ViewChild('imgInput') imgInput:ElementRef;

    imageBace: string = '';
    isLoading = true;
    isNew = false;
    errorFromServer = ErrorCode.Success;
    pagination: Pagination;
    sorting: Sorting;
    collections: Collection[];
    groupTypes = GroupType;
    @ViewChild('modal')
    modal: ModalComponent;
    editingUser:Collection = new Collection();
    form: FormGroup;
    businessTypes = BusinessType;
    displayPocSelection = false;
    search: string = "";
    private _searchStrem = new Subject<string>();

    private _subscription: Subscription;

    constructor(private _userService: UserService,
                private _http: HttpClient,
                private element: ElementRef,
                private route: ActivatedRoute,
                private _builder: FormBuilder,
                private _countryService: CountryService) {
    }

    private getUsersAccordingToParams() {
        this._subscription = this.route
            .queryParams
            .subscribe(params => {
                this.loadCollections();
            });
    }
    debug(e){
      let arr = e.split(/\s+/);
      if(arr.length > 1) {
        arr.forEach((el, i) => {
          arr[i] = el.replace(/[^0-9]/g, '');
          if(this.lotIds.indexOf(arr[i]) != -1) {
            if(this.lotIds) {
              if(!this.findInArr(el)) {
                this.editingUser.lot_id.push(el);
                this.lotIdsSelect.active.push({id: el, text: el});
              }
            }else{
/*              this.lotIds = [{id: el, text: el}];
              this.lotIdsSelect.active = [{id: el, text: el}];*/
            }
          }
        })
        if(this.lotIdsSelect.inputMode) {
          this.lotIdsSelect.open()
        }
        this.lotIdsSelect.inputValue = '';
        this.lotIdsSelect.element.nativeElement.firstElementChild.children[2].value = ''
        setTimeout(()=>{this.lotIdsSelect.inputValue = '';},200)
      }
    }
    findInArr(id:any){
      if(this.editingUser.lot_id) {
        let flag = false;
        this.editingUser.lot_id.forEach(el => {
          if(!flag && el == id) {
            flag = true;
          }
        })
        return flag;
      }else{
        return false;
      }
    }

    findInArr2(id:any){
      if(this.lotIds) {
        let flag = false;
        this.lotIds.forEach(el => {
          if(!flag && el.id == id) {
            flag = true;
          }
        })
        return flag;
      }else{
        return false;
      }
    }

    private loadCollections() {
        this.isLoading = true;
        this.getCollections()
            .subscribe(
                response => {
                    this.errorFromServer = response.error;
                    this.pagination = response.pagination;
                    this.sorting = response.sorting;
                    this.collections = response.collections;
                    this.collections.forEach((el,i)=>{
                      if(el.white == null) {
                        this.collections[i].white = new White();
                      }
                      if(el.fancy == null) {
                        this.collections[i].fancy = new Fancy();
                      }
                    })
                },
                null,
                () => this.isLoading = false
            );
    }

    private buildForm() {
        this.form = this._builder.group({
            role: [
                ''
            ],
            poc: [
                ''
            ],
            defaultMarkup: [
                ''
            ]
        });
    }


    ngOnInit() {
      this.getDiamondList()
      this.getUsersAccordingToParams();
      this.buildForm();

      this._searchStrem
          .debounceTime(1000)
          .distinctUntilChanged()
          .subscribe(search => {
              this.loadCollections();
          });

      $('body').on('input', '.debug_class input', (e) => {
        this.debug($(e.target).val());
      })
    }

    ngOnDestroy() {
      $( "body" ).off( "input", ".debug_class input" );
    }

    groupTypeChange() {/*
        let usersGroup = this.editingUser.permissions.group_id;

        this.displayPocSelection = usersGroup == GroupType.Client || usersGroup == GroupType.Collaborator || usersGroup == GroupType.Viewer;*/
    }

    openEditModal(user?: any) {
      if(user) {
        this.isNew = false;
        let tmp = JSON.stringify(user)
        this.editingUser = JSON.parse(tmp);
        this.modal.open();
      }else{
        this.isNew = true;
        this.editingUser = new Collection();
        this.editingUser.price = {
          minimum: -1,
          maximum: -1,
        }
        this.modal.open();
      }
    }
    openModal(user:any, modalFrom:any){//imageModal
      let tmp = JSON.stringify(user)
      this.editingUser = JSON.parse(tmp);
      modalFrom.open();
    }
    saveUser() {

        this.modal.close();
    }

    private getDiamondList() {
        this._http.get(
            "/diamonds.json"
        ).subscribe(items => {
                items.diamonds.forEach((el:any)=>{
                    this.lotIds.push('' + el.lot_id);
                    if(el.pair) {
                        this.lotIds.push('' + el.pair.lot_id);
                    }
                    let flag = true;
                    this.locations.forEach((curel) => {
                      if(flag && ''+curel.toLowerCase() == el.location.toLowerCase()) {
                        flag = false;
                      }
                    })
                    if(flag && el.location) {
                      this.locations.push(el.location);
                    }
                })
            });
    }

    toggItems(item:any, add:boolean, type:string){
        let flag:any = false;
        this.editingUser[type].forEach((el, i) => {
            if(el == item.text && flag === false) {
                flag = i;
            }
        })

        if(flag === false) {
            if(add) {
                this.editingUser[type].push(item.text);
            }
        }else{
            if(!add) {
                this.editingUser[type].splice(flag, 1)
            }
        }
    }
    triggerClick(event:any){
      if($(event.target).closest('.dropdown-menu').length > 0) {
        return;
      }
      $('body').trigger('click')
    }
    private getUserArrayIndexById(userId: number) {
        var index: number;

        this.collections.forEach((user, i) => {
            if (user.id == userId) {
                index = i;
                return;
            }
        });

        return index;
    }

    performSearch(search) {
        this.search = search;
        this._searchStrem.next(search);
    }

    getCollections() {
        return this._http.get(
            "/collection/all"
        );
    }

    refreshValue(val:any, type:string, sType?:string){
      if(sType) {
        this.editingUser[type][sType] = [];
        val.forEach((el)=>{
          this.editingUser[type][sType].push(el.text)
        })
        return;
      }
      this.editingUser[type] = [];
      val.forEach((el)=>{
        this.editingUser[type].push(el.text)
      })
    }

    deleteImage(){
      this.isLoading = true;
      this._http.post(
          "/collection/removeimage",
          {'id': this.editingUser.id}
      ).subscribe(
          response => {
            this.loadCollections()
          },
          null,
          () => {this.loadCollections()}
      );
    }

    saveImage(){
      this.isLoading = true;
      this._http.post(
          "/collection/updateimage",
        {
          'id': this.editingUser.id,
          "image": this.imageBace
        }
      ).subscribe(
          response => {
            this.loadCollections()
          },
          null,
          () => {this.loadCollections()}
      );
    }

    changeListner(event) {
      var reader = new FileReader();
      var image = this.el.nativeElement;
      reader.onload = (e) => {
          var src = e.target['result'];
          this.imageBace = src;
          image.src = src;
      };

      if(event.target.files[0]) {
        reader.readAsDataURL(event.target.files[0]);
      }

    }
    refresh(){
      this.imgInput.nativeElement.value = "";
      this.imageBace = '';
      this.el.nativeElement.src = '';
    }
    ChangeOrder(){
      this.isLoading = true;
      this._http.post(
          "/collection/order",
        {
          'id': this.editingUser.id,
          "display_order": this.editingUser.display_order
        }
      ).subscribe(
          response => {
            this.loadCollections()
          },
          null,
          () => {this.loadCollections()}
      );
    }
    removeCollection(){
      this.isLoading = true;
      this._http.post(
          "/collection/remove",
        {
          'id': this.editingUser.id,
        }
      ).subscribe(
          response => {
            this.loadCollections()
          },
          null,
          () => {this.loadCollections()}
      );
    }
    saveCollection(newCol?:boolean){
      this.isLoading = true;
      let coll = new Collection();
      coll.name = this.editingUser.name;
      coll.description = this.editingUser.description;
      coll.search_type = this.editingUser.search_type;

      if(this.editingUser.search_type == 3) {
        coll.lot_id = this.editingUser.lot_id;
        coll.white = null;
        coll.fancy = null;
      }else{
        coll.shape = this.editingUser.shape;
        coll.size = this.editingUser.size;
        coll.price = this.editingUser.price;
        coll.clarity = this.editingUser.clarity;
        coll.color = this.editingUser.color;
        coll.polish = this.editingUser.polish;
        coll.symmetry = this.editingUser.symmetry;
        coll.fluorescence = this.editingUser.fluorescence;
        coll.lab = this.editingUser.lab;
        coll.find_pair = this.editingUser.find_pair;
        coll.mounted = this.editingUser.mounted;
        coll.location = this.editingUser.location;
        if(this.editingUser.search_type == 1) {
          coll.fancy = this.editingUser.fancy;
          coll.white = null;
        }else{
          coll.white = this.editingUser.white;
          coll.fancy = null;
        }
      }

      if(this.isNew) {

        this._http.post(
            "/collection/new",
          {
            'collection': coll,
          }
        ).subscribe(
            response => {
              this.loadCollections()
            },
            null,
            () => {this.loadCollections()}
        );

      }else{

        coll.id = this.editingUser.id;
        this._http.post(
            "/collection/edit",
          {
            'collection': coll,
          }
        ).subscribe(
            response => {
              this.loadCollections()
            },
            null,
            () => {this.loadCollections()}
        );

      }

    }
}



// WEBPACK FOOTER //
// ./src/app/collection/collection.component.ts